module.exports = __webpack_public_path__ + "static/images/a447527e0f2c85978a2e2da63fe3ef2d.webp";